import React, { useState, useEffect, useRef } from "react";
import "../../../Content/Styles/SuperCasinoUtrkeWidget.less";
import RiveComponent from "../Shared/RiveComponent";
import Flickity from 'flickity';
import 'flickity/css/flickity.css';
export const SuperCasinoUtrkeWidget = (props) => {

    // Slider reference, HizmanB
    const carouselRef = useRef(null);
    const flickityInstance = useRef(null);
    const dataPromises = useRef(null);
    const [races, setRaces] = useState([]);
    const [promoPage, setPromoPage] = useState(false);

    // Render podaci, HizmanB
    const playButtonName = `Saznaj više`;
    const findMoreButtonName = `Saznaj više`;
    const fullUtrkeUrl = `${casino.config.urls.mobile}casino-utrke/`;
    const serverUrl = 'https://cdn.supersport.hr';

    const formatirajDatum = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";

        const dan = date.getDate();
        const mjesec = date.getMonth() + 1;
        const sati = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');

        return `${dan}.${mjesec}. U ${sati}:${minute}h`;
    };

    const odrediStatusUtrke = (startTimeStr, endTimeStr) => {
        const sada = new Date();
        const pocetak = new Date(startTimeStr);
        const kraj = new Date(endTimeStr);

        if (isNaN(pocetak.getTime()) || !kraj.getTime()) return "ZAVRŠENO";

        if (sada < pocetak) {
            return "USKORO";
        } else if (sada >= pocetak && sada <= kraj) {
            return "AKTIVNA";
        } else {
            return "ZAVRŠENO";
        }
    };

    const formatirajNagradu = (iznos) => {
        if (iznos === undefined || iznos === null || isNaN(iznos)) return "0,00 €";

        return new Intl.NumberFormat('hr-HR', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2
        }).format(iznos);
    };

    const setData = (data) => {
        setRaces(data);
    };

    const getData = () => {
        dataPromises.current = casino.utils.makeCancelablePromise(
            casino.repos.casinoUtrkeIHGRepo.get(
                casino.config.casinoRestApiUrl,
                casino.config.casinoRestApiKey
            )
        );
        dataPromises.current.promise.then(setData, function (reason) { });
    };

    useEffect(() => {
        getData();

        return () => {
            if (dataPromises.current && dataPromises.current.cancel) {
                dataPromises.current.cancel();
            }
        };
    }, []);

    useEffect(() => {
        setPromoPage(props.promoPage);
    }, [props.promoPage]);

    useEffect(() => {
        if (carouselRef.current && races.length > 0) {
            flickityInstance.current = new Flickity(carouselRef.current, {
                cellAlign: 'center',
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                draggable: true,
                contain: false,
                freeScroll: false,
                cellSelector: '.utrkeElement'
            });
        }

        return () => {
            if (flickityInstance.current) {
                flickityInstance.current.destroy();
            }
        };
    }, [races]);

    return (
        <div className="utrkeWidget">
            <RiveComponent
                className="utrkeRive"
                lazyLoad={true}
                cacheBust={`c=${casino.config.guiCacheVerzija}`}
                src={`${serverUrl}/Casino/Images/SuperCasinoUtrkeWidget/Web/SuperCasinoUtrkeWidget_web.riv`}
                useOffscreenRenderer={true}
                playRequest={true}
                disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px" }}
            />
            <div
                className={promoPage ? "utrkeTitlePromo" : "utrkeTitle"}
                style={{ backgroundImage: `url('${serverUrl}/Casino/Images/SuperCasinoUtrkeWidget/Web/SuperCasinoUtrkeWidget_title.png')` }}
            />
            <div className={promoPage ? "utrkeSliderWrapperPromo" : "utrkeSliderWrapper"}>
                <div className="utrkeSlider" ref={carouselRef}>
                    {races.map((element, index) => {
                        const status = odrediStatusUtrke(element.startTimeUTC, element.endTimeUTC);
                        return (
                            <div className="utrkeElement" key={`${element.tournamentID}-${index}`}>
                                <div className="utrkeElementBackground"/>
                                <div
                                    className="utrkeElementLogo"
                                    style={{ backgroundImage: `url('${element.image}')` }}
                                />
                                <div className="utrkeElementTitle">{element.tournamentName}</div>
                                <div className="utrkeElementReward">{formatirajNagradu(element.rewardsSum)}</div>
                                <div className="utrkeElementActive">
                                    {status}
                                </div>
                                <div className="utrkeElementTime">
                                    {status !== "ZAVRŠENO" && (
                                        <div className="utrkeElementTime">
                                            {status === "AKTIVNA" ? "DO " : "OD "}
                                            {formatirajDatum(status === "AKTIVNA" ? element.endTimeUTC : element.startTimeUTC)}
                                        </div>
                                    )}
                                </div>
                                <button className="utrkeElementSaznajVise">
                                    <a className="utrkeElementLinkAnchor" href={`${fullUtrkeUrl}${element.tournamentID}`}>{findMoreButtonName}</a>
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={promoPage ? "utrkeStatsPromo" : "utrkeStats"}>
                <span className="utrkeStatsText">Trenutno aktivnih utrka:</span>
                <span className="utrkeStatsNumber">{races.filter(r => odrediStatusUtrke(r.startTimeUTC, r.endTimeUTC) === "AKTIVNA").length}</span>
                <span className="utrkeStatsText">Utrke koje uskoro počinju:</span>
                <span className="utrkeStatsNumber">{races.filter(r => odrediStatusUtrke(r.startTimeUTC, r.endTimeUTC) === "USKORO").length}</span>
            </div>
            <button className={promoPage ? "utrkeZaigrajPromo" : "utrkeZaigraj"}>
                <span className="utrkeIcon">
                    {/*Arrow svg*/}
                    <svg width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"></path>
                    </svg>
                </span>
                <a className="utrkeLink" href={`${casino.config.urls.mobile}casino-utrke`}>{playButtonName}</a>
            </button>
            <div
                className="utrkeBackground"
                style={{ backgroundImage: `url('${serverUrl}/Casino/Images/SuperCasinoUtrkeWidget/Web/SuperCasinoUtrkeWidget_background.jpg')` }}
            />
        </div>
    );
};